import { useScrollReveal } from '@/hooks/useScrollReveal';

const reasons = [
  {
    icon: 'ri-global-line',
    title: 'Asset-Light, Network-First',
    description: 'We don\'t own the trucks or warehouses — we connect them. Every asset on the network earns more because it\'s part of a larger, smarter system.',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Standard SKU Trust',
    description: 'Every product is cut, graded, and specified consistently — so a buyer in Mumbai can order from a warehouse in Kochi with complete confidence in what arrives.',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-node-tree',
    title: 'Two-Sided Network Effect',
    description: 'More supply attracts more buyers, better matching drives better prices. Every new partner makes the entire network more valuable for everyone.',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-flag-2-line',
    title: 'Built for India\'s Cold Chain',
    description: 'Regional harvest calendars, FSSAI compliance, HACCP-audited facilities — designed from the ground up for how India produces, moves, and consumes frozen food.',
    color: 'bg-secondary-100 text-secondary-700',
  },
];

export default function WhyFreshhlockSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 warm-sand-bg">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Our Advantage
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Why Freshhlock
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto">
            Four reasons why the network approach beats the old way of moving frozen food.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="group bg-card-50 border border-card-200 rounded-xl p-6 md:p-8 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-pointer card-animate"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${reason.color} mb-5 animate-icon-float icon-hover-pop`}>
                <i className={`${reason.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-primary-700 text-base mb-3">
                {reason.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}